import axios from "axios"
import { Base64 } from "js-base64"
import globalConfig from "@/config/config.js"
import mobile from "is-mobile"
import { isIos } from "@/utils/cookie"
import { $$language , setLangetoServer} from "@/i18n/i18n.js"
import { firebaseUtils } from "@/utils/analytic/firebaseUtils.js"
export const getCookie = (cookie, name) => {
  let cookieStr = cookie ? cookie : !import.meta.env.SSR ? document.cookie : ""
  const match = cookieStr.match(new RegExp("(^| )" + name + "=([^;]+)"))
  return match ? decodeURIComponent(match[2]) : null
}

export function createAxiosInstance (ssrCtx) {
  const getUserAgent = async () => {
    //  return 'en/1.0.1/h5//web/635e3f65711348759f54180b91220156/unknown//3x';
    const cookie = ssrCtx.ssrHeaders?.Cookie
    const osVersion = isIos(ssrCtx.ssrHeaders["User-Agent"]) ? "ios" : "android"
    const json = getCookie(cookie ?? "", "sensorsdata2015jssdkcross")
    const first_id = json ? JSON.parse(json)?.first_id : ""
    const deviceId = first_id ? first_id : await firebaseUtils?.getAnonymousID()
    const netType = "unknown"
    const deviceType = ""
    const resolution = "3x"
    const plantform = mobile() ? "h5" : "web"
    const x_plantform = "web"
    const cookieData = getCookie(cookie ?? "", globalConfig.localStorageGlobalKey)
    const { appLanguage } = JSON.parse(decodeURIComponent(cookieData)) ?? {}
    return [setLangetoServer(appLanguage), globalConfig.version, plantform, osVersion, x_plantform, deviceId, netType, deviceType, resolution].join("/")
  }

  const _headers = {
    "Content-Type": "application/json",
    Accept: "application/json",
  }

  if (ssrCtx) {
    _headers["SSR-Headers"] = JSON.stringify(ssrCtx.ssrHeaders)
    _headers["SSR-Render-ID"] = ssrCtx.renderId?.toString()
    if (ssrCtx.ssrHeaders.Cookie) {
      const gaInfo = ssrCtx.ssrHeaders.Cookie.match(/_ga=(.+?);/)?.[1] ?? ""
      const gaUserId = gaInfo?.split(".")?.slice(-2)?.join(".") ?? ""
      const sadata = getCookie(ssrCtx?.ssrHeaders?.Cookie, "sensorsdata2015jssdkcross")
      _headers["X-Firebase-Id"] = gaUserId
      _headers["X-Source"] = sadata ? Base64.encode(sadata) : ""
      _headers["X-Auth-Timestamp"] = Math.floor(new Date().getTime())
      _headers["X-App-Name"] = globalConfig.appname
      _headers["X-User-Agent"] = getUserAgent()
    }
  }

  const instance = axios.create({
    headers: _headers,
    timeout: 10000,
  })

  instance.defaults.withCredentials = true
  instance.interceptors.request.use((config) => {
    return config
  })

  instance.interceptors.response.use(
    (response) => {
      const res = response?.data ?? {}

      if (res.code === 0) {
        res.code = 200
      }
      return res
    },
    (err) => {
      console.error("axios response error:", err.stack)
      return err
    }
  )

  return async function (url, data = {}, options = {}) {
    const { method = "get", headers = {}, ...rest } = options

    const config = {
      url,
      method,
      headers,
      ...rest,
    }

    if (method.toLowerCase() === "get") {
      config.params = data
    } else {
      config.data = data
    }

    return instance(config)
  }
}
